import { render, staticRenderFns } from "./salesReturnsEdit_v3.vue?vue&type=template&id=4a085818&scoped=true&"
import script from "./salesReturnsEdit_v3.vue?vue&type=script&lang=js&"
export * from "./salesReturnsEdit_v3.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnsEdit_v3.vue?vue&type=style&index=0&id=4a085818&lang=less&scoped=true&"
import style1 from "./salesReturnsEdit_v3.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a085818",
  null
  
)

component.options.__file = "salesReturnsEdit_v3.vue"
export default component.exports